import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Menu, Icon, Label } from 'semantic-ui-react'
import LaneEditor from '../LaneEditor/LaneEditor.jsx'
import './LanesSidebar.scss'

/**
 * View component for LanesSidebar
 * Renders the sidebar navigation for lanes management
 */
export const LanesSidebarView = ({
  activeCount,
  archiveCount,
  activeHref,
  archivedHref,
}) => {
  return (
    <Menu text vertical className='app-side-nav lanes-side-nav'>
      <Menu.Item
        as={NavLink}
        end
        to={'/'}
        data-automation-id={'return-to-marketplace'}
        data-testid='lanes-sidebar-home-link'
      >
        <Icon name='chevron left' />
        Return to Home Screen
      </Menu.Item>
      <hr />
      {/* ###### Create ##### */}
      <div className='item'>
        <Menu.Item as={LaneEditor} data-testid='lanes-sidebar-create-link'>
          <Icon name='add square' />
          Create New Lane
        </Menu.Item>
      </div>
      <hr />
      {/* ##### Links ##### */}
      <div className='link-list'>
        <Menu.Item
          as={NavLink}
          to={activeHref}
          data-testid='lanes-sidebar-active-link'
        >
          <Icon name='folder' />
          Active
          <Label content={activeCount} />
        </Menu.Item>
        <Menu.Item
          as={NavLink}
          to={archivedHref}
          data-testid='lanes-sidebar-archived-link'
        >
          <Icon name='history' />
          Archived
          <Label content={archiveCount} />
        </Menu.Item>
      </div>
    </Menu>
  )
}

LanesSidebarView.propTypes = {
  activeCount: PropTypes.number.isRequired,
  archiveCount: PropTypes.number.isRequired,
  activeHref: PropTypes.string.isRequired,
  archivedHref: PropTypes.string.isRequired,
}
